import { cn } from '@/utils/cn';

interface Props {
  children: React.ReactNode;
}

export const Modal = ({ children }: Props) => {
  return (
    <div
      data-testid="checkout-modal"
      className={cn('fixed inset-0 z-50', 'bg-black/50', 'sm:p-6', 'flex items-center justify-center', 'landscape:p-0')}
    >
      <div
        data-testid="checkout-modal-content"
        className={cn(
          'bg-white sm:rounded-xl',
          'w-full h-full md:max-w-[976px] md:max-h-[871px]',
          'sm:w-[90vw] sm:h-[90vh]',
          'transform transition-all duration-300',
          'md:overflow-y-auto',
          'relative',
          'sm:shadow-2xl sm:shadow-gray-900/20',
          'flex flex-col',
          'landscape:w-full landscape:h-[100dvh] landscape:max-w-full landscape:max-h-full',
          'landscape:rounded-none landscape:shadow-none landscape:border-0 landscape:overflow-hidden'
        )}
      >
        {children}
      </div>
    </div>
  );
};
